module.exports    = {
	"title": "Create pages from TOML!",
	"imagine": "What you can do with raw data",
	"integrationsWithOtherSystems": {
		"possible": true,
		"awesome": true
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./examples/toml.toml
 ** module id = 529
 ** module chunks = 0
 **/